import React, { useContext } from "react";
import { useState } from "react";
import "../../css_files/Master/AddCategoryMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddCategoryMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  categoryupdatedata,
}) {
  const [categoryData, setCategoryData] = useState({
    Name: triggerupdate ? categoryupdatedata?.name : "",
    Description: triggerupdate ? categoryupdatedata?.description : "",
  });
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/Category/UpdateCategory`;
      axiosInstance
        .post(url, {
          id: categoryupdatedata.id,
          name: categoryData.Name,
          description: categoryData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/Category`;
      axiosInstance
        .post(url, categoryData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error(error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }

  return (
    <form className="add-category-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Category Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Category Master Name"
          value={categoryData.Name}
          onChange={(e) =>
            setCategoryData({ ...categoryData, Name: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/Category/GetCategoryByIdOrName?name=${e.target.value}`
              )
              .then(() => setMessage("Category with this Name Already Exists"))
              .catch((error) => {
                setMessage("");
              });
          }}
          required
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Maximum 400 Characters)"
          value={categoryData.Description}
          onChange={(e) =>
            setCategoryData({ ...categoryData, Description: e.target.value })
          }
          onInput={(e) => (e.target.value = e.target.value.slice(0, 400))}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"}</button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddCategoryMaster;
